import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import logo from '../../../src/assets/logo.png';

function SuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [orderId, setOrderId] = useState('');
  
  useEffect(() => {
    const orderIdParam = searchParams.get('order_id');
    if (orderIdParam) {
      setOrderId(orderIdParam);
    }
  }, [searchParams]);

  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <img src={logo} alt="Ixoria Logo" style={{ height: '80px', marginBottom: '20px' }} />
      </Box>
      <Box sx={{ 
        bgcolor: '#f0f9f0', 
        p: 4, 
        borderRadius: 2, 
        borderLeft: '6px solid #4caf50',
        mb: 4
      }}>
        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: '#4caf50', mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
          Order Confirmed! 🎉
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
          Your journey to clearer skin starts now!
        </Typography>
        <Typography variant="h6" color="text.secondary" paragraph>
          Thank you for your purchase!
        </Typography>
        
        <Box sx={{ mt: 3, p: 3, bgcolor: 'white', borderRadius: 2, textAlign: 'left' }}>
          <Typography variant="subtitle1" gutterBottom>
            Your order has been placed successfully.
          </Typography>
          {orderId && (
            <Typography variant="body1" color="text.secondary">
              Order ID: <strong>{orderId}</strong>
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            We will notify you with all the details.
          </Typography>
        </Box>
        
        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            onClick={() => navigate('/')}
            sx={{ 
              py: 1.5, 
              borderRadius: 2,
              bgcolor: '#0a716e',
              '&:hover': {
                bgcolor: '#085b58',
              },
              px: 4
            }}
          >
            Explore More
          </Button>
          
        </Box>
      </Box>
      
      <Box sx={{ mt: 4, p: 3, bgcolor: '#f5f5f5', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>What's next?</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Our team is already preparing your order. You'll receive a shipping confirmation message with tracking information as soon as it's on its way!
        </Typography>
        <Typography variant="body2" color="text.secondary">
          For any questions about your order, please contact us at <strong>ixoriaherbalproject@gmail.com</strong>
        </Typography>
      </Box>
      
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Thank you for choosing Ixoria. We're excited to be part of your skincare journey! ✨
        </Typography>
      </Box>
    </Container>
  );
}

export default SuccessPage;
